// AccessSelectorScreen
export const ACCESS_SELECTOR_TITLE = 'How do you access Sleepio?';
export const NHS_OPTION = 'Free access through the NHS';
export const RESEARCH_OPTION = 'I am part of a Research Study';
export const EMPLOYER_OPTION = 'Google UK';

// CountrySelectorScreen
export const COUNTRY_SELECTOR_TITLE = 'Where do you live?';
export const ENGLAND_OPTION = 'England';
export const SCOTLAND_OPTION = 'Scotland';
export const WALES_OPTION = 'Wales';
export const NORTHERN_IRELAND_OPTION = 'Northern Ireland';

// NHSLoginScreen
export const NHS_LOGIN_TITLE = 'Choose your login method';
export const NHS_LOGIN_SUBTITLE =
  'Use the same login method that you created your account with.';
export const NHS_LOGIN_EMAIL_PATH_PREFIX =
  "If you didn't create an account with NHS login, ";
export const NHS_LOGIN_EMAIL_PATH_LINK = 'click here';
export const NHS_LOGIN_TROUBLE = 'Having trouble?';
export const NHS_LOGIN_CONTACT_PREFIX = 'Contact us at ';
export const NHS_LOGIN_CONTACT_EMAIL_ADDRESS = 'hello@sleepio.com';
export const NHS_LOGIN_CONTACT_EMAIL = 'mailto:hello@sleepio.com';

// Shared
export const CONTINUE_BUTTON = 'Continue';
